import React from "react";

export function SectionTag({ children, className = "" }) {
  return (
    <span className={`inline-block font-mono text-[11px] uppercase tracking-[0.25em] text-brand-textDim ${className}`}>
      {children}
    </span>
  );
}

export function SectionTitle({ children, className = "" }) {
  return (
    <h2 className={`font-heading text-3xl tracking-tight text-white sm:text-4xl lg:text-5xl ${className}`}>
      {children}
    </h2>
  );
}

export function SectionSub({ children, className = "" }) {
  return (
    <p className={`max-w-2xl text-base leading-relaxed text-brand-textDim ${className}`}>
      {children}
    </p>
  );
}
